
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    theme: {
      type: String,
      required: true,
    },

    size: {
      type: String,
    },

    outline: {
      type: Boolean,
      default: false,
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    btnClass(): string {
      const classes = [];
      classes.push('btn');
      if (this.outline) {
        classes.push('btn-outline-' + this.theme);
      } else {
        classes.push('btn-' + this.theme);
      }
      if (this.size) {
        classes.push('btn-' + this.size);
      }
      if (this.loading) {
        classes.push('disabled');
      }

      return classes.join(' ');
    },
  },
});
